import React from "react";
import "../theme/Administracion.css";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { TableAdministracionRemitentes } from "../components/TableAdministracionRemitentes";
import { useNavigate } from "react-router-dom";
import { useDynamicAuth } from "../context/AuthProviderContext"; // Importar el hook

export const AdminPageRemitentes = () => {
  const navigate = useNavigate();
  const authProvider = useDynamicAuth();

  return (
    <AzureAD provider={authProvider}>
      {({ authenticationState, accountInfo }) => {
        const isAuthenticated = authenticationState === AuthenticationState.Authenticated;

        if (isAuthenticated) {
          return (
            <div className="body-color">
              <div className="title-name-admin">
                <div className="icon-goback-title-admin">
                  <button className="button-goback-style" onClick={() => navigate(-1)}>
                    <ArrowBackIosIcon />
                  </button>
                  <div> Administración de Remitentes </div>
                </div>
              </div>

              <TableAdministracionRemitentes />
            </div>
          );
        }
      }}
    </AzureAD>
  );
};
